
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const startDateInput = document.getElementById("start-date")
    const endDateInput = document.getElementById("end-date")
    if (startDateInput) startDateInput.dataset.previousValue = startDateInput.value
    if (endDateInput) endDateInput.dataset.previousValue = endDateInput.value
  }

  updateDate(event) {
    const startDateInput = document.getElementById("start-date");
    const endDateInput = document.getElementById("end-date");

    // Get the previous valid values from data attributes
    const previousStartDate = startDateInput.dataset.previousValue || startDateInput.value;
    const previousEndDate = endDateInput.dataset.previousValue || endDateInput.value;

    const startDate = new Date(startDateInput.value);
    const endDate = new Date(endDateInput.value);

    if (startDate && endDate) {
      if (endDate < startDate) {
        alert("End date must be greater than the start date.");
        if (event.target.id === "end-date") {
          endDateInput.value = this.formatDateForInput(previousEndDate, endDateInput);
        } else if (event.target.id === "start-date") {
          startDateInput.value = this.formatDateForInput(previousStartDate, startDateInput);
        }
        return;
      }
    }

    startDateInput.dataset.previousValue = startDateInput.value;
    endDateInput.dataset.previousValue = endDateInput.value;

    this.submitFormWithAction(this.data.get("filterUrl"));
  }

  resetDates() {
    this.submitFormWithAction(this.data.get("resetUrl"));
  }

  submitFormWithAction(actionUrl) {
    const form = document.getElementById("ai-actions-form");
    form.setAttribute("action", actionUrl);
    form.removeAttribute("data-remote");
    form.submit();
  }

  formatDateForInput(dateString, inputEl) {
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    if (inputEl && inputEl.type === "date") {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  }
}
